/**
 * Type-specific section composition for ahoy_meeting.
 *
 * Meetings render TWO type-specific sections (SchedulerBookingSection
 * showing the booking link if one exists, then MeetingDetailSection with
 * the AI prep brief / meeting summary tabs). The registry expects a SINGLE
 * component per `components.typeSpecific` slot, so this wrapper composes
 * them and threads `onRequestNoteCreation` through to the detail section.
 *
 * The recurring-series list is NOT here — it renders via the registry's
 * `beforeTimeline` slot so it sits directly above the activity timeline.
 */

import type { CrmObject } from '@/types/crm';

import { MeetingDetailSection } from './meeting-detail-section';
import { SchedulerBookingSection } from './scheduler-booking-section';

interface MeetingTypeSpecificProps {
  object: CrmObject;
  /** Forwarded to MeetingDetailSection — clicked by users to jump to the
   *  parent slideout's NotesSection in create mode. */
  onRequestNoteCreation?: () => void;
}

export function MeetingTypeSpecific({
  object,
  onRequestNoteCreation,
}: MeetingTypeSpecificProps) {
  return (
    <>
      <SchedulerBookingSection object={object} />
      <MeetingDetailSection
        object={object}
        onRequestNoteCreation={onRequestNoteCreation}
      />
    </>
  );
}
